import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class PackageService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  findPackage(packageId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/find",{
    params : {
     id:packageId,
    }
   }).map(response => response.json().package);
  }

  isAvailable(packageId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/is_available",{
    params : {
     packageId:packageId,
    }
   }).map(response => response.json());
  }

  isFound(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/is_found",{
    params : params
   }).map(response => response.json());
  }

  getSupplierPackages(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get",{
    params : {
     eventId:eventId,
     type:'Supplier'
    }
   }).map(response => response.json().packages);
  }

  saveSupplierPackage(params): Observable<any> {
   params.type = 'Supplier';
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/save", params, this.options).map(response => response.json());
  }

  getDistributorPackages(eventId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get",{
    params : {
     eventId:eventId,
     type:'Distributor'
    }
   }).map(response => response.json().packages);
  }

  getGuestPackages(eventId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get",{
    params : {
     eventId:eventId,
     type:'Guest'
    }
   }).map(response => response.json().packages);
  }

  saveDistributorPackage(params): Observable<any> {
   params.type = 'Distributor';
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/save", params, this.options).map(response => response.json());
  }

  saveGuestPackage(params): Observable<any> {
   params.type = 'Guest';
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/save", params, this.options).map(response => response.json());
  }

  getActivityLimits(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get_activity_limits",{
    params : {
     packageId:params.packageId
    }
   }).map(response => response.json().activityLimits);
  }

  saveActivityLimit(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/"+(params.id?'edit_activity_limit':'add_activity_limit'), params, this.options).map(response => response.json());
  }

  findActivityLimit(activityLimitId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/find_activity_limit",{
    params : {
     id:activityLimitId,
    }
   }).map(response => response.json().activityLimit);
  }

  getFeatureLimits(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get_feature_limits",{
    params : {
     packageId:params.packageId
    }
   }).map(response => response.json().featureLimits);
  }

  saveFeatureLimit(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/"+(params.id?'edit_feature_limit':'add_feature_limit'), params, this.options).map(response => response.json());
  }

  findFeatureLimit(featureLimitId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/find_feature_limit",{
    params : {
     id:featureLimitId,
    }
   }).map(response => response.json().featureLimit);
  }

  getBenefits(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/package/get_benefits",{
    params : {
     packageId:params.packageId
    }
   }).map(response => response.json().benefits);
  }

  deletePackage(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/delete", params, this.options).map(response => response.json());
  }

  deleteActivityLimit(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/delete_activity_limit", params, this.options).map(response => response.json());
  }

  deleteFeatureLimit(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/delete_feature_limit", params, this.options).map(response => response.json());
  }

  deleteBenefit(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/delete_benefit", params, this.options).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/package.service.ts